import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function ChangeReference({ onSelect, onClose }) {
  const [references, setReferences] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadData = async () => {
    try {
      // Pobieramy wszystkie wgrane wcześniej referencje
      const response = await axios.get('https://megamont.pl/api/references');
      setReferences(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Błąd podczas ładowania referencji:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1050 }} tabIndex="-1">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg">
          
          <div className="modal-header bg-dark text-white">
            <h5 className="modal-title fw-bold">Wybierz Plik Referencyjny</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>

          <div className="modal-body p-4" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status"></div>
                <p className="mt-2">Wczytywanie bazy referencji...</p>
              </div>
            ) : references.length > 0 ? (
              <div className="row">
                {references.map((ref) => (
                  <div className="col-md-3 col-sm-4 col-6 mb-3" key={ref.id}>
                    <div 
                      className="card h-100 reference-select-card" 
                      onClick={() => onSelect(ref)}
                      style={{ cursor: 'pointer', transition: 'transform 0.2s' }}
                    >
                      <div className="p-2 d-flex align-items-center justify-content-center" style={{ height: '150px', backgroundColor: '#f8f9fa' }}>
                        <img 
                          src={`https://megamont.pl/uploads/references/${ref.name}`} 
                          alt={ref.name}
                          className="img-fluid"
                          style={{ maxHeight: '100%', objectFit: 'contain' }}
                        />
                      </div>
                      <div className="card-footer p-1 text-center bg-white border-top-0">
                        <small className="text-muted" style={{ fontSize: '10px' }}>ID: #{ref.id}</small>
                        <button className="btn btn-sm btn-primary w-100 mt-1">Wybierz</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-5">
                <p className="text-muted">Brak referencji w bazie. Dodaj je najpierw w Panelu Referencji.</p>
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary px-4" onClick={onClose}>Zamknij</button>
          </div>

        </div>
      </div>
      
      {/* Opcjonalny styl CSS dla efektu hover */}
      <style>{`
        .reference-select-card:hover {
          transform: scale(1.03);
          border-color: #0d6efd !important;
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
        }
      `}</style>
    </div>
  );
}